<onyx-information-heading [identifierColor]="identifierColor()">
  {{ `map.swapPanel.setChanges` | translate }}
</onyx-information-heading>

<div class="swap-set">
  @if (vehicle(); as vehicle) {
    <app-map-swap-panel-details-section-swap-point-item
      [color]="identifierColor() ?? 'blue'"
      [iconName]="`${vehicle.generalInformation.category}-filled`"
      [inactive]="true"
      variant="modal"
      (openModal)="openFleetModal(vehicle)"
    >
      {{ vehicle | fleetIdentifier }}
    </app-map-swap-panel-details-section-swap-point-item>
  }

  @for (item of trailers(); track trackTrailer(item, $index)) {
    @switch (item.type) {
      @case ('dropped') {
        <app-map-swap-panel-details-section-swap-point-item
          [action]="SwapSetAction.DROP_OFF_IN_POINT"
          [type]="type()"
          [color]="identifierColor() ?? 'blue'"
          [iconName]="`${item.trailer.generalInformation.category}-filled`"
          [inactive]="true"
          variant="modal"
          (openModal)="openFleetModal(item.trailer)"
        >
          <p class="line-through">{{ item.trailer | fleetIdentifier }}</p>
        </app-map-swap-panel-details-section-swap-point-item>
      }

      @case ('trailer') {
        @let data = item.data;
        @if (data.value; as trailer) {
          <app-map-swap-panel-details-section-swap-point-item
            [action]="data.action"
            [type]="type()"
            [color]="identifierColor() ?? 'blue'"
            [iconName]="`${trailer.generalInformation.category}-filled`"
            [forceActive]="!!data.isManuallyAdded"
            [inactive]="true"
            variant="modal"
            (openModal)="openFleetModal(trailer)"
          >
            <p
              [class.line-through]="
                data.action === SwapSetAction.DROP_OFF_IN_POINT
              "
            >
              @if (data.action === SwapSetAction.SWAP && item.initialTrailer) {
                <span>{{ item.initialTrailer | fleetIdentifier }} → </span>
              }

              <span>{{ trailer | fleetIdentifier }}</span>
            </p>

            @if (data.isManuallyAdded && data.action === SwapSetAction.NONE) {
              <span description>
                {{
                  `map.swapPanel.new.${trailer.generalInformation.category}`
                    | translate
                }}
              </span>
            }
          </app-map-swap-panel-details-section-swap-point-item>
        }
      }

      @case ('placeholder') {
        <app-map-swap-panel-details-section-swap-point-item
          [color]="identifierColor() ?? 'blue'"
          iconName="trailer-filled"
          [inactive]="true"
          [placeholder]="true"
        >
          {{ item.placeholder | translate }}
        </app-map-swap-panel-details-section-swap-point-item>
      }
    }
  }

  @for (item of drivers(); track trackDriver(item, $index)) {
    @if (item.type === 'driver') {
      @let data = item.data;
      @if (data.value; as driver) {
        <app-map-swap-panel-details-section-swap-point-item
          [action]="data.action"
          [type]="type()"
          [color]="identifierColor() ?? 'blue'"
          iconName="steering-wheel-filled"
          [forceActive]="!!data.isManuallyAdded"
          [inactive]="true"
          variant="modal"
          (openModal)="openDriverModal(driver)"
        >
          <p
            [class.line-through]="
              data.action === SwapSetAction.DROP_OFF_IN_POINT
            "
          >
            {{ driver.driverData | onyxName }}
          </p>

          @if (data.isManuallyAdded && data.action === SwapSetAction.NONE) {
            <span description>{{ 'map.swapPanel.newDriver' | translate }}</span>
          }
        </app-map-swap-panel-details-section-swap-point-item>
      }
    } @else {
      <app-map-swap-panel-details-section-swap-point-item
        [color]="identifierColor() ?? 'blue'"
        iconName="no-user-filled"
        [inactive]="true"
        [placeholder]="true"
      >
        {{ item.placeholder | translate }}
      </app-map-swap-panel-details-section-swap-point-item>
    }
  }

  @for (item of activeOrders(); track trackOrder(item, $index)) {
    @if (item.value; as order) {
      <app-map-swap-panel-details-section-swap-point-item
        [action]="item.action"
        [type]="type()"
        [color]="identifierColor() ?? 'blue'"
        iconName="good-filled"
        [forceActive]="item.action !== SwapSetAction.NONE"
        [inactive]="true"
        variant="modal"
        (openModal)="openOrderModal(order)"
      >
        <p
          [class.line-through]="
            SwapDetailsHelper.INACTIVE_ORDER_ACTIONS.includes(item.action)
          "
        >
          @let label = SwapHelper.getOrderLabel(order);
          {{ label.type }} · {{ label.identifier }}
        </p>
      </app-map-swap-panel-details-section-swap-point-item>
    }
  }
</div>
